import { render, staticRenderFns } from "./ProcessCharacteristicsDialog.vue?vue&type=template&id=fa1831ac&scoped=true"
import script from "./ProcessCharacteristicsDialog.vue?vue&type=script&lang=js"
export * from "./ProcessCharacteristicsDialog.vue?vue&type=script&lang=js"
import style0 from "./ProcessCharacteristicsDialog.vue?vue&type=style&index=0&id=fa1831ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1831ac",
  null
  
)

export default component.exports